export default __webpack_public_path__ + "static/media/885.4450d9a2.png";